import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FieldArrayWithId, UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from 'react-hook-form';
import { ICuadreInventarioForm } from '@/shared/interfaces/erp/inventario/cuadre-inventario.interface';
import { Grid, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { CustomTextField } from '@/shared/components/ui';
import { EstadoCuadreENUM, gridSizeMdLg10, gridSizeMdLg2 } from '@/shared';

interface EmailModalCuadreProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  form: UseFormReturn<ICuadreInventarioForm, any, ICuadreInventarioForm>
  fields: FieldArrayWithId<ICuadreInventarioForm, "correos", "id">[]
  append: UseFieldArrayAppend<ICuadreInventarioForm, "correos">
  remove: UseFieldArrayRemove
  onSubmitHandler: (e?: React.BaseSyntheticEvent) => void
}

export default function EmailModalCuadre({
  open,
  setOpen,
  form,
  fields,
  append,
  remove,
  onSubmitHandler
}: EmailModalCuadreProps) {

  const {
    formState: { errors }
  } = form


  const handleClose = () => {
    setOpen(false);
    form.setValue('estado_cuadre', EstadoCuadreENUM.BORRADOR)
  };




  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>¡Confirmar!</DialogTitle>
      <DialogContent>

        <Grid container spacing={3} justifyContent={'space-between'}>
          <Grid item xs={12}>

            <DialogContentText>
              Al finalizar esta acción se generará un movimiento de inventario y no podrá deshacerse.¿Estás seguro de que deseas continuar?
            </DialogContentText>
          </Grid>
          <Grid item xs={8}>
            <Typography variant='subtitle2'>
              Ingresar correo
            </Typography>
          </Grid>

          <Grid item >
            <Button
              size='small'
              color='inherit'
              variant='text'
              startIcon={<Add />}
              onClick={() => {
                append({
                  correo: ''
                })
              }}
            >
              Agregar
            </Button>

          </Grid>


          {
            fields.map((field, index) => {

              const itemErrors = errors.correos?.[index];

              return (
                <Grid
                  key={field.id}
                  container item spacing={3}>

                  <CustomTextField
                    name={`correos.${index}.correo`}
                    label={`Correo ${index + 1}`}
                    control={form.control}
                    defaultValue={
                      field.correo || ""
                    }
                    type='email'
                    error={itemErrors?.correo}
                    helperText={itemErrors?.correo?.message}
                    size={gridSizeMdLg10}
                  />

                  <Grid item {...gridSizeMdLg2}>

                    <Button
                      color="secondary"
                      onClick={() => {
                        remove(index)
                      }}
                      disabled={fields.length === 1}
                    >
                      Eliminar
                    </Button>
                  </Grid>
                </Grid>

              )
            })
          }

        </Grid>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={onSubmitHandler}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
